const getJsonLdScriptId = (type?: string) => {
    if (type === "HomePage") {
        return "home-page-structured-data";
    }

    if (type === "ProductDetailsPage") {
        return "product-structured-data";
    }

    if (type === "ProductListPage" || type === "CategoryDetailsPage" || type === "BrandDetailsPage") {
        return "breadcrumb-structured-data";
    }

    return "";
};

export default getJsonLdScriptId;
